import { render } from "./statistics-list.vue?vue&type=template&id=9fc0d8ce&ts=true"
import script from "./statistics-list.ts?vue&type=script&lang=ts"
export * from "./statistics-list.ts?vue&type=script&lang=ts"

import "./statistics-list.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__